import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Services.css';

const servicesData = [
    {
        id: 'elyconcierge',
        image: '/elyconciergeservice.webp',
        alt: 'Ely Concierge',
        link: '/elyconcierge',
    },
    {
        id: 'elyfleet',
        image: '/elyfleetservice.webp',
        alt: 'Ely Fleet',
        link: '/elyfleet',
    },
    {
        id: 'elydine',
        image: '/elydineservice.webp',
        alt: 'Ely Dine',
        link: '/elydine',
    },
    {
        id: 'elyventory',
        image: '/elyventoryservice.webp',
        alt: 'Ely Ventory',
        link: '/elyventory',
    },
];

const Services = () => {
    const navigate = useNavigate();

    return (
        <section className="services" id="services" data-aos="fade-up">
            <div className="services-container">
                <div className="section-header">
                    <h2 data-text="Ely Services">Ely Services</h2>
                    <p>Transformative solutions designed to elevate your business.</p>
                </div>
                <div className="services-grid">
                    {servicesData.map((service, index) => (
                        <div
                            className="service-card"
                            key={service.id}
                            data-aos="fade-up"
                            data-aos-delay={100 * (index + 1)}
                        >
                            <img
                                src={service.image}
                                alt={service.alt}
                                className="service-sq-image"
                                loading="lazy"
                            />
                            <div className="service-hover-overlay">
                                <button
                                    className="service-know-more-btn"
                                    onClick={() => navigate(service.link)}
                                >
                                    Know More
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;